import Conf from "./Conf"
import Log from "./Log";
import PhpRegex from "./PhpRegex"
import Storage from "./Storage";

export default class Appearance {
  static async waitForAppearance(a) {
    Log.info(`Handling appearance`, a)
    let promises = []

    try {
      if (a?.viewport_shown?.enabled) {
        promises.push(new Promise((resolve, reject) => {
          let timeout = null
          const el = document.querySelector(a.viewport_shown.selector)
          if (!el) {
            reject('Selector does not exists')
            return
          }

          const func = () => {
            const bounding = el.getBoundingClientRect();
            if (
              bounding.bottom - bounding.height <=
              (window.innerHeight || document.documentElement.clientHeight)
            ) {
              resolve(a)
              window.removeEventListener('scroll', timeoutFunc, false)
              return true
            }
            return false
          }
          const timeoutFunc = () => {
            if (timeout !== null) {
              clearTimeout(timeout)
            }
            timeout = setTimeout(func, 500)
          }
          if (func()) {
            return
          }

          window.addEventListener('scroll', timeoutFunc, false)
        }))
      }

      if (a?.wait?.enabled) {
        promises.push(new Promise((resolve, reject) => {
          setTimeout(_ => {
            Log.debug(`a is`, a)
            resolve(a)
          }, a.wait.delay * 1000)
        }))
      }

      if (a?.viewport_percent?.enabled) {
        promises.push(new Promise((resolve, reject) => {
          const func = () => {
            const bounding = document.body.getBoundingClientRect()
            let notViewed =
              bounding.bottom -
              (window.innerHeight || document.documentElement.clientHeight)
            if (notViewed < 0) notViewed = 0

            const percentage = ((bounding.height - notViewed) / bounding.height) * 100
            if (percentage > a.viewport_percent.value) {
              resolve(a)
              window.removeEventListener('scroll', timeoutFunc, false)
              return true
            }
            return false
          }
          const timeoutFunc = () => {
            if (timeout !== null) {
              clearTimeout(timeout)
            }
            timeout = setTimeout(func, 500)
          }
          if (func()) {
            return
          }

          window.addEventListener('scroll', timeoutFunc, false)
        }))
      }

      if (a?.pageview_count?.enabled) {
        promises.push(new Promise(async (resolve, reject) => {
          const key = `${Conf.get().chatbotId}-pages-count`
          const actualCount = +(await Storage.get(key, 0, true))
          const newCount = actualCount + 1
          await Storage.set(key, newCount + '', true)

          if (newCount >= a.pageview_count.value) {
            resolve(a)
          } else {
            reject('Pages count not high enough')
          }
        }))
      }

      return await Promise.any(promises)
    } catch (err) {
      Log.debug(err)
    }
  }

  static wait(conf = null) {
    let appearances = []
    if (conf === null) {
      conf = Conf.get().appearances
    }
    const url = window.location.pathname + window.location.search
    conf = conf.filter(
      appearance => {
        let matches = {
          inclusive: 0,
          exclusive: 0
        }
        appearance.patterns.forEach(pattern => {
          matches[pattern.type] += PhpRegex.parse(pattern.pattern).test(url)
            ? 1
            : 0
        })

        if (!matches.exclusive && !matches.inclusive) return false
        return !matches.exclusive
      }
    )

    for (let appearance of conf) {
      appearances.push(this.waitForAppearance(appearance))
    }

    return Promise.any(appearances).catch(e => Log.debug("Global appearance wait returned", e))
  }
}
